export const userProfileIconsV3 = {
  authenticationIcon: "20-locker-closed-v3",
  billingIcon: "20-card-v3",
  paywallsAffiliatesIcon: "20-affiliates-v3",
  viewProfileIcon: "20-user-v3",
  editProfileIcon: "20-edit-v3",
  notificationIcon: "20-bell-v3",
  signOutIcon: "20-sign-out-v3",
} as const;
